import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Link from '@src/components/link';
import useAnchorScrollSpy from '@src/utils/hooks/use-anchor-scroll-spy';
import ComponentStore from './store';
const styles = require('./index.less');

// 顶部/侧栏锚点导航的目标 = CMS HTML 内写死的小节 id（顺序与导航项一致）
// TODO: 锚点 id 依赖 CMS 正文内的 id，须与本届真实 CMS 内容一致；占位期沿用上一届文章，id 可能不匹配
const ANCHORS = ['战域领土', '荣耀嘉奖', '战域匹配'];

// 背景与公共组件导航已上提到 list 页统一渲染，内页只负责自身锚点导航 + CMS 正文
const BattleTerritory = ({ store, className }) => {
  store.use();
  // 顶部/侧栏锚点滚动 + scrollspy + 固定侧栏显隐（与其余内页共用同一 hook）
  const { activeAnchor, showSidebar, scrollToAnchor, scrollToTop } = useAnchorScrollSpy(ANCHORS);

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.group1} data-name={'战域领土内页'}>
        <div className={styles.group2} data-name={'内容'}>
          <div className={cx(styles.group3, styles.fadeInDown)} data-name={'cms主体内容区'}>
            {/* 单篇 CMS HTML，内含写死 id 锚点小节，由 store 归一化输出 contentHtml */}
            <div
              className={styles.layer2}
              data-name={'cms内容 - 包含文字 + 图片; 使用dangerouslySetInnerHTML来转换'}
              dangerouslySetInnerHTML={{ __html: store.contentHtml }}
            />
          </div>
          <div className={cx(styles.group4, styles.fadeInUp)} data-name={'顶部导航条'}>
            <div className={styles.layer3} data-name={'顶部标题'} />
            <div className={styles.group5} data-name={'顶部导航按钮'}>
              <div className={styles.layer4} data-name={'按钮组背景'} />
              <div className={styles.group6} data-name={'按钮组list'}>
                <Link
                  className={cx(styles.group7, { [styles.active]: activeAnchor === '战域匹配' })}
                  data-name={'战域匹配'}
                  onClick={() => scrollToAnchor('战域匹配')}
                >
                  <div className={styles.layer5} data-name={'战域匹配-常态'} />
                  <div className={styles.layer6} data-name={'战域匹配-选中/悬停'} />
                </Link>
                <Link
                  className={cx(styles.group8, { [styles.active]: activeAnchor === '荣耀嘉奖' })}
                  data-name={'荣耀嘉奖'}
                  onClick={() => scrollToAnchor('荣耀嘉奖')}
                >
                  <div className={styles.layer7} data-name={'荣耀嘉奖-常态'} />
                  <div className={styles.layer8} data-name={'荣耀嘉奖-选中/悬停'} />
                </Link>
                <Link
                  className={cx(styles.group9, { [styles.active]: activeAnchor === '战域领土' })}
                  data-name={'战域领土'}
                  onClick={() => scrollToAnchor('战域领土')}
                >
                  <div className={styles.layer9} data-name={'战域领土-常态'} />
                  <div className={styles.layer10} data-name={'战域领土-选中/悬停'} />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className={cx(styles.group10, { [styles.visible]: showSidebar })} data-name={'右侧侧栏导航'}>
          <div className={styles.layer11} data-name={'侧栏背景'} />
          <div className={styles.group11} data-name={'侧栏按钮组'}>
            <Link className={styles.group12} data-name={'返回顶部'} onClick={scrollToTop}>
              <div className={styles.layer12} data-name={'返回顶部-常态'} />
              <div className={styles.layer13} data-name={'返回顶部-选中/悬停'} />
            </Link>
            <Link
              className={cx(styles.group13, { [styles.active]: activeAnchor === '战域匹配' })}
              data-name={'战域匹配'}
              onClick={() => scrollToAnchor('战域匹配')}
            >
              <div className={styles.layer14} data-name={'战域匹配-常态'} />
              <div className={styles.layer15} data-name={'战域匹配-选中/悬停'} />
            </Link>
            <Link
              className={cx(styles.group14, { [styles.active]: activeAnchor === '荣耀嘉奖' })}
              data-name={'荣耀嘉奖'}
              onClick={() => scrollToAnchor('荣耀嘉奖')}
            >
              <div className={styles.layer16} data-name={'荣耀嘉奖-常态'} />
              <div className={styles.layer17} data-name={'荣耀嘉奖-选中/悬停'} />
            </Link>
            <Link
              className={cx(styles.group15, { [styles.active]: activeAnchor === '战域领土' })}
              data-name={'战域领土'}
              onClick={() => scrollToAnchor('战域领土')}
            >
              <div className={styles.layer18} data-name={'战域领土-常态'} />
              <div className={styles.layer19} data-name={'战域领土-选中/悬停'} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default wrapStore(BattleTerritory, ComponentStore);
